import React from 'react'

import { Button } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.colors.violet[100],
  color: theme.colors.violet[700],
  fontWeight: 500,
  fontSize: 'inherit',
  lineHeight: 'inherit',
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: theme.colors.violet[400],
  },
}))

const AccentLink = ({ ...rest }) => {
  return <StyledButton variant='text' {...rest} />
}

export default AccentLink
